import React, { useState } from 'react';
import {
  FiMapPin,
  FiPhone,
  FiMail,
  FiClock,
  FiSend,
  FiCheck,
  FiInstagram,
  FiLinkedin,
} from 'react-icons/fi';
import {
  ContactContainer,
  ContactContent,
  ContactHeader,
  ContactGrid,
  ContactInfo,
  ContactForm,
  InfoItem,
  FormGroup,
  Label,
  Input,
  Textarea,
  SubmitButton,
  SocialLinks,
  SocialButton,
  FloatingShape,
  SuccessMessage,
  BackgroundNumber
} from '../styles/ContactStyle';
import PageLayout from '../components/PageLayout';
import Footer from '../components/Footer';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
    setTimeout(() => setIsSubmitted(false), 5000);
  };

  return (
    <PageLayout>
      <ContactContainer>
        <BackgroundNumber>442</BackgroundNumber>
        <FloatingShape className="shape1" />
        <FloatingShape className="shape2" />
        
        <ContactContent>
          <ContactHeader>
            <h1>Get in Touch</h1>
            <p>Have a question or want to work together? We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
          </ContactHeader>

          <ContactGrid>
            <ContactInfo>
              <InfoItem>
                <h3>
                  <FiMapPin />
                  Visit Us
                </h3>
                <p>Studio 442<br />578 Nepperhan Avenue<br />Yonkers, NY 10701</p>
              </InfoItem>

              <InfoItem>
                <h3>
                  <FiPhone />
                  Call Us
                </h3>
                <p>
                  <a href="tel:+19144507466">+1 (914) 450-7466</a>
                </p>
              </InfoItem>

              <InfoItem>
                <h3>
                  <FiMail />
                  Email Us
                </h3>
                <p>
                  <a href="mailto:team@studio442.co">team@studio442.co</a>
                </p>
              </InfoItem>

              <InfoItem>
                <h3>
                  <FiClock />
                  Operation Hours
                </h3>
                <p>Monday - Friday: 9:00 AM - 6:00 PM<br />
                   Saturday: 10:00 AM - 4:00 PM<br />
                   Sunday: Closed</p>
              </InfoItem>

              <SocialLinks>
                <SocialButton href="https://instagram.com/studio.442" target="_blank">
                  <FiInstagram />
                </SocialButton>
                <SocialButton href="https://linkedin.com/studio442" target="_blank">
                  <FiLinkedin />
                </SocialButton>
              </SocialLinks>
            </ContactInfo>

            <ContactForm onSubmit={handleSubmit}>
              <FormGroup>
                <Label htmlFor="name">Name</Label>
                <Input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Your name"
                />
              </FormGroup>

              <FormGroup>
                <Label htmlFor="email">Email</Label>
                <Input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="Your email address"
                />
              </FormGroup>

              <FormGroup>
                <Label htmlFor="subject">Subject</Label>
                <Input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="What is this regarding?"
                />
              </FormGroup>

              <FormGroup>
                <Label htmlFor="message">Message</Label>
                <Textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Your message"
                />
              </FormGroup>

              <SubmitButton type="submit">
                Send Message
                <FiSend />
              </SubmitButton>

              {isSubmitted && (
                <SuccessMessage>
                  <FiCheck />
                  Thank you! Your message has been sent successfully.
                </SuccessMessage>
              )}
            </ContactForm>
          </ContactGrid>
        </ContactContent>
        <Footer />
      </ContactContainer>
    </PageLayout>
  );
}

export default Contact;